export default function() {
    return {
        carts: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        search: {
            'trip.agency.name': null,
            'since': null
        },
        searchParams: {
            agencyName: null,
            status: null,
            requestNumber: null,
            name: null,
            phone: null,
            since: null,
        },
        places: [],
        apiUrl: process.env.VUE_APP_API_URL,

        fields: [
            {
                key: 'agencyName',
                label: 'Agência'
            },
            {
                key: 'destination',
                label: 'Destino'
            },
            {
                key: 'buyerName',
                label: 'Comprador'
            },
            {
                key: 'buyerPhone',
                label: 'Telefone'
            },
            {
                key: 'date',
                label: 'Data do carrinho'
            },
            {
                key: 'duration',
                label: 'Data da trip'
            }
        ]
    }
}
